import { render } from "./DeleteConfirmationModal.vue?vue&type=template&id=5dd1e9c2"
import script from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmationModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shohei/workspace/soei_project/measure_rep_mng/vue3_measure_rep_mng/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__